import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 4c3.016 0 5.444 1.404 7.199 2.943 1.754 1.538 2.906 3.271 3.4 4.09.36.597.36 1.337 0 1.933-.494.82-1.646 2.553-3.4 4.091C17.444 18.596 15.016 20 12 20s-5.444-1.404-7.199-2.943c-1.754-1.538-2.906-3.271-3.4-4.09a1.867 1.867 0 0 1 0-1.933c.494-.82 1.646-2.553 3.4-4.091C6.556 5.404 8.984 4 12 4zm0 2C9.636 6 7.659 7.097 6.12 8.447 4.626 9.757 3.613 11.248 3.154 12c.459.752 1.472 2.243 2.966 3.553C7.66 16.903 9.636 18 12 18s4.341-1.097 5.88-2.447c1.494-1.31 2.507-2.801 2.966-3.553-.459-.752-1.472-2.243-2.966-3.553C16.34 7.097 14.364 6 12 6zm0 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }